import { useState } from "react";
import { toast } from "sonner";
import { useDealerTemplateOptions, useSetWaTemplateFields } from "../../../lib/api";
import { PrimaryButton, Select } from "../primitives";
import { placeholderNumbers } from "./templateFormat";

// Which field fills each {{n}} of this template. Every Service journey stage that picks the
// template uses these, so they are set once, here.
export default function TemplateFieldsCard({ row, tenantId }) {
  const { data: options } = useDealerTemplateOptions(tenantId);
  const save = useSetWaTemplateFields(tenantId);
  const [map, setMap] = useState(row.field_map || {});
  const numbers = placeholderNumbers(row.body);
  if (!numbers.length || !["text", "image", "video", "document"].includes(row.template_type || "text")) return null;
  const examples = row.body_examples || [];
  const ready = numbers.every((n) => map[n]);
  const changed = JSON.stringify(map) !== JSON.stringify(row.field_map || {});

  const onSave = async () => {
    try {
      await save.mutateAsync({ id: row.id, field_map: map });
      toast.success("Fields saved.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "The fields were not saved. Try again.");
    }
  };

  return (
    <section className="rounded-2xl bg-white p-5 ring-1 ring-inset ring-[#EAECF0] shadow-[0_1px_2px_rgba(16,24,40,0.06),0_4px_12px_rgba(16,24,40,0.08)]">
      <h3 className="m-0 mb-4 text-[15px] font-semibold text-[#101828]">Fields</h3>
      <div className="flex flex-col gap-3">
        {numbers.map((n) => (
          <div key={n} className="grid grid-cols-[56px_minmax(0,1fr)] items-center gap-3">
            <span className="rounded-md bg-[#F2F4F7] py-[9px] text-center font-mono text-[12.5px] font-medium text-[#344054]" title={examples[n - 1] ? `Example: ${examples[n - 1]}` : undefined}>
              {`{{${n}}}`}
            </span>
            <Select aria-label={`Field for {{${n}}}`} value={map[n] || ""} onChange={(e) => setMap((m) => ({ ...m, [n]: e.target.value }))} className="w-full">
              <option value="">Select field</option>
              {(options?.fields || []).map((f) => (
                <option key={f.key} value={f.key}>
                  {f.label}
                </option>
              ))}
            </Select>
          </div>
        ))}
      </div>
      {changed && (
        <div className="mt-4 flex justify-end">
          <PrimaryButton onClick={onSave} disabled={!ready || save.isPending}>
            {save.isPending ? "Saving" : "Save fields"}
          </PrimaryButton>
        </div>
      )}
    </section>
  );
}
